import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import DataTable from '../components/data-table/data-table';
import Navbar from '../components/navbar';
import { GeneralAccountModal } from '../components/account-modal/account-modal';
import AccountModal from '../components/profile-modal/account-search-modal';
import RouteLoading from '../components/route-loading';
import TableFilter from '../components/table-filter';
import AccountFilterTooltip from '../components/profile-modal/account-search-filter-tooltip';


class AccountsPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  filterBy = observable({
    'all': '',
    'index': '',
    'account_id': '',
    'name': '',
    'panels': [],
    'managers': [],
    'teamleads': [],
    'scouts': [],
    'operators': [],
    'account-managers': [],
    'levels': [],
    'nick': '',
    'email': ''
  });

  filterNames = observable({
    'all': 'По всем',
    'index': '№',
    'account_id': 'ID',
    'name': 'ФИО',
    'panels': 'Пан',
    'managers': 'Менеджер',
    'teamleads': 'Тимлид',
    'scouts': 'Скаут',
    'operators': 'Оператор',
    'levels': 'Уровень',
    'account-managers': 'ММ',
    'nick': 'Ник',
    'email': 'Email'
  });

  coreFilterNames = {
    'по всем': 'all',
    'panel': 'panels',
    'full_name': 'name',
    'manager': 'managers',
    'form_level': 'levels',
    'team_lead': 'teamleads',
    'scout': 'scouts',
    'account_manager': 'account-managers',
    'operator': 'operators',
    'nick': 'nick',
    'id': 'account_id',
    'number': 'index',
    'email': 'email'
  };

  reverseCoreFilterNames = {
    'panels': 'panel',
    'name': 'full_name',
    'managers': 'manager',
    'levels': 'form_level',
    'teamleads': 'team_lead',
    'operators': 'operator',
    'scouts': 'scout',
    'account-managers': 'account_manager',
    'nick': 'nick',
    'account_id': 'id',
    'index': 'number',
    'all': 'по всем',
    'email': 'email'
  };

  levelOptions = [
    { id: "1", title: "1" },
    { id: "2", title: "2" },
    { id: "3", title: "3" },
    { id: "4", title: "4" },
    { id: "5", title: "5" },
  ]

  localStateExample = {
    isModalOpened: false,
    isAccountModalOpened: false,
    selectedProfileId: null,
    selectedOptions: [
      'all', 'panels', 'name', 'managers', 'teamleads', 'operators', 'scouts', 'account-managers',
      'levels', 'nick', 'account_id', 'index', 'email'
    ],
    accountModalOptions: [
      { value: 'all', label: 'По всем' },
      { value: 'panels', label: 'Панель' },
      { value: 'name', label: 'ФИО' },
      { value: 'managers', label: 'Менеджер' },
      { value: 'teamleads', label: 'Тимлид' },
      { value: 'operators', label: 'Оператор' },
      { value: 'scouts', label: 'Скаут' },
      { value: 'account-managers', label: 'ММ' },
      { value: 'levels', label: 'Уровень' },
      { value: 'nick', label: 'Ник' },
      { value: 'account_id', label: 'ID' },
      { value: 'index', label: '№' },
      { value: 'email', label: 'Email' }],
    currentPage: 1,
    tooltipOpened: false,
    search: {
      filter_by: JSON.parse(JSON.stringify(this.filterBy)),
      accountFilters: [],
      sort_by: null,
      lastSearch: null,
      status: 'active',
      page_size: 15
    }
  };

  constructor(props) {
    super(props);
    this.localState = observable(JSON.parse((localStorage.getItem(`accountLocalState_${this.store.auth.currentHost}`))) || this.localStateExample);
  }

  lastSorting = new Map();

  localSearchState = observable({
    status: 'active',
    page_size: 15
  });

  onModalClose = action(() => {
    this.localState.isModalOpened = false;
    this.localState.selectedProfileId = null;
    this.store.accounts.originalModel = null;
    this.store.accounts.model = null;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onModalOpen = action(profileId => {
    this.localState.selectedProfileId = profileId;
    this.localState.isModalOpened = true;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onAccountModalClose = action(() => {
    this.localState.isAccountModalOpened = false;
    this.localState.tooltipOpened = true;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onAccountModalOpen = action(profileId => {
    this.localState.isAccountModalOpened = true;
    this.localState.tooltipOpened = false;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onSearchTooltipClose = action(() => {
    this.localState.tooltipOpened = false;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onSearchTooltipOpen = action(() => {
    this.localState.tooltipOpened = true;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  });

  onSearchItemsClear = (value) => {
    const itemsToDelete = this.localState.search.accountFilters.filter((option) => option.type === this.reverseCoreFilterNames[value]);
    this.localState.search.accountFilters = this.localState.search.accountFilters.filter(item => !itemsToDelete.includes(item));
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onMultiSelectChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      this.localState.selectedOptions = [...this.localState.selectedOptions, value];
      localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
    } else {
      this.onSearchItemsClear(value);
    }
  };

  onSearchItemDelete = (value) => {
    this.localState.selectedOptions = this.localState.selectedOptions.filter((option) => option !== value);
    this.onSearchItemsClear(value);
    this.localState.search.filter_by[value] = JSON.parse(JSON.stringify(this.filterBy[value]));
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onFilterByChange = (value, name) => {
    this.localState.search.filter_by[name] = value;
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  saveColumnPreset = async preset => {
    await this.actions.accountsActions.saveColumnPreset(preset);
  };

  updateTableFilters = () => {

    for (const searchRaw in this.localState.search.filter_by) {
      if (['panels', 'managers', 'teamleads', 'scouts', 'operators', 'levels', 'account-managers'].includes(searchRaw)) {
        this.onSearchItemsClear(searchRaw);
        this.localState.search.filter_by[searchRaw].forEach(data => {
          this.localState.search.accountFilters.push({
            type: this.reverseCoreFilterNames[searchRaw],
            label: this.filterNames[searchRaw],
            value: data
          });
        }
        );

      } else {
        const isFilterAlreadyExist = this.localState.search.accountFilters.find(
          f => f.type === this.reverseCoreFilterNames[searchRaw]);

        if (!isFilterAlreadyExist) {
          this.localState.search.accountFilters.push({
            type: this.reverseCoreFilterNames[searchRaw],
            value: this.localState.search.filter_by[searchRaw],
            label: this.filterNames[searchRaw],
            isServerSide: true
          });
        }

        if (this.localState.search.filter_by[searchRaw]) {
          this.localState.search.accountFilters = this.localState.search.accountFilters.map(item => (
            item.type === this.reverseCoreFilterNames[searchRaw] ?
              {
                type: item.type,
                value: this.localState.search.filter_by[searchRaw],
                label: item.label,
                isServerSide: true
              } :
              item));
        } else {
          const idx = this.localState.search.accountFilters.findIndex(
            f => f.type === this.reverseCoreFilterNames[searchRaw]);
          if (idx !== -1) {
            this.localState.search.accountFilters.splice(idx, 1);
          }
        }
      }
      localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
    }
  };

  onSearchChange = async searchString => {
    if (searchString.target) {
      this.localState.search.filter_by.all = searchString.target.value
    } else {
      this.localState.search.filter_by.all = ''
    }
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onSearchClick = () => {
    this.localState.tooltipOpened = false;
    this.lastPage = 1;
    this.localState.search.status = this.localSearchState.status.value ?
      this.localSearchState.status.value : 'active';

    this.localState.search.page_size = this.localSearchState.page_size.value ?
      this.localSearchState.page_size.value : 15;

    this.updateTableFilters();

    this.actions.accountsActions.refreshAccounts(
      this.localState.search.filter_by,
      this.lastPage,
      this.lastSorting,
      this.localState.search.filter_by.all,
      this.localState.search.page_size,
      this.localState.search.status
    );
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onSearchFilterChange = searchString => {
    if (searchString.target) {
      this.localState.search.filter_by[searchString.target.name] = searchString.target.value;
      localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
    }
  };

  onChangeFilters = async found_filter => {
    if (found_filter.is_new) {
      if (['panel', 'manager', 'form_level', 'team_lead', 'operator', 'account_manager', 'scout'].includes(found_filter.type)) {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]].push(found_filter.value);
      } else {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = found_filter.value;
      }
    } else {
      if (['panel', 'manager', 'form_level', 'team_lead', 'operator', 'account_manager', 'scout'].includes(found_filter.type)) {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = this.localState.search.filter_by[
          this.coreFilterNames[found_filter.type]].filter(item => item !== found_filter.value);
      } else {
        this.localState.search.filter_by[this.coreFilterNames[found_filter.type]] = '';
      }
    }
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onPageChange = async page => {
    this.localState.currentPage = page;
    this.lastPage = page;
    await this.actions.accountsActions.refreshAccounts(
      this.localState.search.filter_by,
      this.lastPage,
      this.lastSorting,
      this.localState.search.filter_by.all,
      this.localState.search.page_size,
      this.localState.search.status
    );
    localStorage.setItem(`accountLocalState_${this.store.auth.currentHost}`, JSON.stringify(this.localState));
  };

  onSortChange = (header, mode) => {

    if (mode === 'none') {
      this.lastSorting.delete(header);
    } else {
      this.lastSorting.set(header, mode);
    }

    this.lastPage = 1;
    this.actions.accountsActions.refreshAccounts(
      this.localState.search.filter_by,
      this.lastPage,
      this.lastSorting,
      this.localState.search.filter_by.all,
      this.localState.search.page_size,
      this.localState.search.status
    );

    localStorage.setItem(
      `accountLocalState_${this.store.auth.currentHost}`,
      JSON.stringify(this.localState));
  };

  render() {
    const { filters, selectors, ui } = this.store.accounts;

    const { changeRounding } = this.actions.accountsActions;

    return (
      <RouteLoading meta={this.store.accounts.meta}>
        <div className='content'>
          <Navbar />
          <div className='under-navbar-content'>
            <TableFilter
              state={filters}
              selectors={selectors}
              onIsFractionalChange={changeRounding}
              withoutFractionalChange
              withoutDatesChange
              withoutStatusChange
              withoutGroupingChange
              withoutFilteringChange
              withSearch={false}
              withCustomSearch={true}
              withColumnsConfigure={false}
              getTableNode={() => this.node}
              render={() => (
                <AccountFilterTooltip
                  isOpen={this.localState.tooltipOpened}
                  onRequestClose={this.onSearchTooltipClose}
                  onStatusChange={value => (this.localSearchState.status = value)}
                  onPageQtyChange={value => (this.localSearchState.page_size = value)}
                  page_size={this.localSearchState.page_size || 15}
                  current_status={this.localSearchState.status || 'active'}
                  options={this.localState.accountModalOptions}
                  onSearchClick={this.onSearchClick}
                  selectedOptions={this.localState.selectedOptions}
                  onSearchItemDelete={this.onSearchItemDelete}
                  onAccountModalOpen={this.onAccountModalOpen}
                  filter_by={this.localState.search.filter_by}
                  onFilterByChange={this.onFilterByChange}
                  onLastSearchChange={this.onSearchFilterChange}
                  filterNames={this.filterNames}
                  onSearchTooltipOpen={this.onSearchTooltipOpen}
                  onSearchChange={this.onSearchChange}
                  levelOptions={this.levelOptions}
                >
                </AccountFilterTooltip>
              )}
            />
            <div className='container' style={{ margin_bottom: '0' }}>
              <div className='inner'>
                <div className='inner-scroll accounts-table'>
                  <Observer>
                    {() =>
                      selectors.filteredData.map((table, idx) => (
                        <DataTable
                          ref={node => (this.node = node)}
                          headerSticky={selectors.filteredData.length > 1 ? false : 50}
                          key={idx}
                          data={table}
                          columnSettings={filters.columnSettings}
                          isDecimalThunk={() => filters.isDecimal}
                          favorites={ui.favorites}
                          initialSortingMap={this.lastSorting}
                          toggleFavorite={this.actions.accountsActions.toggleFavorite}
                          requestModalOpen={this.onModalOpen}
                          isServerSide
                          currentPage={table._meta.page}
                          pageSize={table._meta.page_size}
                          pages={table._meta.pages}
                          onPageChange={this.onPageChange}
                          onSortChange={this.onSortChange}
                          selectors={selectors}
                          name={'accounts'}
                          onRemoveFilter={table._meta ? this.onChangeFilters : undefined}
                          onAddFilter={table._meta ? this.onChangeFilters : undefined}
                          onSearchClick={this.onSearchClick}
                          account_filters={this.localState.search.accountFilters}
                        />
                      ))
                    }
                  </Observer>
                  <Observer>
                    {() => (
                      <GeneralAccountModal
                        isOpened={this.localState.isModalOpened}
                        requestClose={this.onModalClose}
                        accountId={this.localState.selectedProfileId}
                      />
                    )}
                  </Observer>
                  <Observer>
                    {() => (
                      <AccountModal
                        isOpen={this.localState.isAccountModalOpened}
                        onRequestClose={this.onAccountModalClose}
                        options={this.localState.accountModalOptions}
                        selectedOptions={this.localState.selectedOptions}
                        handleChange={this.onMultiSelectChange}
                      />
                    )}
                  </Observer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component()(AccountsPage);
